import { useState as e, useEffect as d } from "react";
function h(n, o, r) {
  const [s, a] = e(!0), [u, c] = e(!1), [f, l] = e(null);
  return d(() => {
    const t = new FontFace(n, `url(${o})`, r);
    l(t), a(!1), t.load().then(() => document.fonts.add(t)).catch(() => c(!0)).finally(() => a(!0));
  }, [r, n, o]), { loaded: s, error: u, font: f };
}
export {
  h as useFont
};
//# sourceMappingURL=useFont.js.map
